import { render, staticRenderFns } from "./MenuEsquerdo.vue?vue&type=template&id=28224cea&scoped=true"
import script from "./MenuEsquerdo.vue?vue&type=script&lang=js"
export * from "./MenuEsquerdo.vue?vue&type=script&lang=js"
import style0 from "./MenuEsquerdo.vue?vue&type=style&index=0&id=28224cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28224cea",
  null
  
)

export default component.exports